var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export default (_a) => {
    var { size } = _a, rest = __rest(_a, ["size"]);
    return (_jsx("svg", Object.assign({ xmlnsXlink: "http://www.w3.org/1999/xlink", width: size, height: size, viewBox: `0 0 16 16` }, rest, { children: _jsx("path", { fill: "currentColor", d: "M8.71 8l5.15-5.15a.5.5 0 10-.71-.71L8 7.29 2.85 2.15a.5.5 0 00-.71.71L7.29 8l-5.14 5.15a.5.5 0 10.71.71L8 8.71l5.15 5.15a.5.5 0 00.71-.71z" }, void 0) }), void 0));
};
